export { HEADERS, TABS, CommonHeaders } from './fileEditingHeaders';
export { DEFAULTS } from './defaults';
export * from './matcher';

export { CUSTOMER_TABS } from './fileEditingHeadersCustomer';

export const CategoriesList = [
  'drug',
  'vaccine',
  'vaccinations',
  'procedure',
  'lab',
  'food',
  'supply',
  'diagnosis',
  'communications',
  'note',
  'problem',
  'vital',
  'wellness',
  'ignore'
];
export const RowsSearchContextsMap = {
  ORIG_NAME: 'orig_name',
  RHAPSODY_NAME: 'rhapsody_name',
  ORIG_CODE: 'orig_code'
};
export const RowsSearchContextLabelsMap = {
  [RowsSearchContextsMap.ORIG_NAME]: 'Original name',
  [RowsSearchContextsMap.RHAPSODY_NAME]: 'Rhapsody name',
  [RowsSearchContextsMap.ORIG_CODE]: 'Original code'
};
export const DEFAULT_ROW_SEARCH_CONTEXT = RowsSearchContextsMap.ORIG_NAME;

export * from './migration';
export * from './file';
export * from './categories';
export * from './statuses';
export * from './rhapsodyConstants';
export * from './breeds';
